import css from './index.module.css'

import { IMAGE_NOT_FOUND } from '#/global/helper/Element/image'

export interface Resolution {
    height: number
    maxWidth?: number
    width: number
}
interface Props {
    alt?: string
    resolutionList: Resolution[]
    src?: string
}

export const Image = ({ alt, resolutionList, src }: Props) => {
    src ??= IMAGE_NOT_FOUND

    const res = [...resolutionList]
    const defaultResolution = res.shift()

    return (
        <picture className="r-image">
            {/* index >= 1 */}
            {res.map(({ height, maxWidth, width }, index) => (
                <source
                    key={index}
                    height={height}
                    media={maxWidth ? `(max-width: ${maxWidth}px)` : undefined}
                    srcSet={src.replace('.webp', `_ew${width}_eh${height}.webp`)}
                    type="image/webp"
                    width={width}
                />
            ))}
            {/* index == 0 */}
            <img
                className={css.image}
                src={src.replace('.webp', `_ew${defaultResolution?.width}_eh${defaultResolution?.height}.webp`)}
                width={defaultResolution?.width}
                height={defaultResolution?.height}
                alt={alt}
            />
        </picture>
    )
}
